export const formActions = {
  Save: 'save',
  Delete: 'delete',
  Load: 'load',
}
